import { useEffect, useState } from 'react';
import { Calendar } from '@/modules/calendar/model/calendar/calendar';
import { selectApi } from '@/modules/calendar/api';

// Calendar slug -> resolved display name. Module-level so a name resolved
// once (or already known synchronously, e.g. from a menu entry's own label
// via SingleCalendarWidget's customTitle) is available immediately to every
// other place that renders the same calendar's title, instead of every
// mount re-fetching and flashing icon-then-text.
const nameCache = new Map<string, string>();

export function getCachedCalendarName(slug: string): string | undefined {
  return nameCache.get(slug);
}

export function cacheCalendarName(slug: string, name: string): void {
  nameCache.set(slug, name);
}

export default function SingleCalendarTitle({ calendarSlug }: { calendarSlug: string }) {
  const [name, setName] = useState<string | undefined>(() => getCachedCalendarName(calendarSlug));

  useEffect(() => {
    const cached = getCachedCalendarName(calendarSlug);
    if (cached) {
      setName(cached);
      return;
    }

    selectApi.getCalendarBySlug(calendarSlug).then((calendar: Calendar) => {
      cacheCalendarName(calendarSlug, calendar.name);
      setName(calendar.name);
    });
  }, [calendarSlug]);

  return <>{name}</>;
}
